
<div class="col-md-12  mt-3">
<div
  #foodLogCard
  class="col-md-6 foodLogs  mt-2"
  [id]="'food-log-' + foodAllInfo.id"
  [class.highlighted-food-log]="isHighlighted">

    <div class="col-md-2 float foodImage">
        <!-- Show barcode icon when source is barcode_scan -->
        <div *ngIf="isBarcodeScan()" class="barcode-placeholder">
            <svg class="barcode-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2 4h2v16H2V4zm4 0h1v16H6V4zm3 0h1v16H9V4zm2 0h2v16h-2V4zm4 0h2v16h-2V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z"/>
            </svg>
        </div>
        <!-- Show food image otherwise -->
        <img *ngIf="!isBarcodeScan()" (click)="showModal(foodAllInfo.foodImageUrl)" class="imgClass" [src]="foodAllInfo.foodImageUrl"/>
    </div>
    <div class="col-md-10 float" [class.has-corner-tag]="hasUpfFood()">
        <div class="col-md-12 foodTitle">
            {{foodAllInfo.name}}<span *ngIf="getTotalServingSize()">, {{getTotalServingSize()}}</span>
        </div>
        <div class="col-md-12 mt-3 padding" >
            <mat-list class="foodDetails" style="display:flex;">
                <mat-list-item class="foodDetails borderRight"> {{foodAllInfo.logTime.split('T')[0] | date:'MMMM dd, y'}} </mat-list-item>
                <mat-list-item class="foodDetails borderRight"> {{getDate(foodAllInfo.logTime.split('T')[1].split('.')[0])}} </mat-list-item>
                <mat-list-item class="foodDetails"> {{foodAllInfo.mealType}} </mat-list-item>
            </mat-list>
        </div>
    </div>

    <!-- Meal Tags - Below date/time -->
    <div class="col-md-12 padding float meal-tags-container">
        <span class="meal-tag" [ngClass]="foodAllInfo.mealLocation === 'Home' ? 'tag-location-home' : 'tag-location-outside'">
            {{foodAllInfo.mealLocation === 'Home' ? '🏠 Home-Cooked' : '🍽️ ' + foodAllInfo.mealLocation}}
        </span>
        <span class="meal-tag tag-upf" *ngIf="hasUpfFood()">
            <img src="assets/img/upf_flag_icon.png" alt="" class="tag-icon" /> Ultra Processed Food
        </span>
        <span class="meal-tag tag-fav" *ngIf="foodAllInfo.isFavorite">
            <img src="assets/img/favorites_icon.png" alt="" class="tag-icon" /> Added to Favorites
        </span>
    </div>

    <!-- Nutrition Grid -->
    <div class="col-md-12 padding float nutrition-grid">
        <div class="nutrition-item">
            <div class="nutrition-label"><span class="legend-circle" style="background:#B18AC7;"></span> Calories</div>
            <div class="nutrition-value">{{Math.round(foodAllInfo.total.calories)}}</div>
            <div class="nutrition-unit">cal</div>
        </div>
        <div class="nutrition-item">
            <div class="nutrition-label"><span class="legend-circle" style="background:#2DD4C7;"></span> Proteins</div>
            <div class="nutrition-value">{{foodAllInfo.total.protein.toFixed(1)}}</div>
            <div class="nutrition-unit">grams</div>
        </div>
        <div class="nutrition-item">
            <div class="nutrition-label"><span class="legend-circle" style="background:#FFB43A;"></span> Carbs</div>
            <div class="nutrition-value">{{foodAllInfo.total.carbs.toFixed(1)}}</div>
            <div class="nutrition-unit">grams</div>
        </div>
        <div class="nutrition-item">
            <div class="nutrition-label"><span class="legend-circle" style="background:#42A5F5;"></span> Fats</div>
            <div class="nutrition-value">{{foodAllInfo.total.fat.toFixed(1)}}</div>
            <div class="nutrition-unit">grams</div>
        </div>
        <div class="nutrition-item">
            <div class="nutrition-label"><span class="legend-circle" style="background:#8BC34A;"></span> Fiber</div>
            <div class="nutrition-value">{{foodAllInfo.total.fiber ? foodAllInfo.total.fiber.toFixed(1) : '0.0'}}</div>
            <div class="nutrition-unit">grams</div>
        </div>
    </div>

    <!-- Alcohol Info Box (shown if any ingredient has alcohol) -->
    <div class="col-md-12 padding float beverage-info-box alcohol-type" *ngIf="hasAlcoholInfo()">
        <div class="beverage-inner">
            <img src="assets/img/alc_icon.png" alt="Alcohol" class="beverage-icon" />
            <div class="beverage-text">
                <div class="beverage-title">Alcohol By Volume (ABV)</div>
                <div class="beverage-description">
                    <ng-container *ngIf="getAlcoholicItemCount() <= 1 || getAlcoholAbvRange().min === getAlcoholAbvRange().max">
                        This drink is <b>{{getAlcoholAbv()}}%</b> ABV and contains <b>{{getAlcoholGrams()}}g</b> of alcohol.
                    </ng-container>
                    <ng-container *ngIf="getAlcoholicItemCount() > 1 && getAlcoholAbvRange().min !== getAlcoholAbvRange().max">
                        These drinks range from <b>{{getAlcoholAbvRange().min.toFixed(1)}}%</b> to <b>{{getAlcoholAbvRange().max.toFixed(1)}}%</b> ABV. Total alcohol: <b>{{getAlcoholGrams()}} g</b>.
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <!-- Caffeine Info Box (shown if any ingredient has caffeine) -->
    <div class="col-md-12 padding float beverage-info-box caffeine-type" *ngIf="hasCaffeineInfo()">
        <div class="beverage-inner">
            <img src="assets/img/caf_icon.png" alt="Caffeine" class="beverage-icon" />
            <div class="beverage-text">
                <div class="beverage-title">Caffeine</div>
                <div class="beverage-description">
                    <ng-container *ngIf="getCaffeinatedItemCount() === 1">
                        This drink has <b>{{getCaffeineAmount()}}mg</b> of caffeine.
                    </ng-container>
                    <ng-container *ngIf="getCaffeinatedItemCount() > 1">
                        This meal contains <b>{{getCaffeineAmount()}}mg</b> of caffeine.
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="editButtonContainer" *ngIf="foodAllInfo.serving == null || hasJournaling()">
        <a href="#" *ngIf="foodAllInfo.serving == null" (click)="openMealInsightsModal($event)" type="submit" class="btnClass btnInsights">Meal Insights</a>
        <a href="#" *ngIf="hasJournaling()" (click)="openJournalingModal($event)" type="submit" class="btnClass btnInsights">Journaling</a>
        <a href="#" (click)="navigateToEdit($event, foodAllInfo)" type="submit" class="btnClass">Edit Food</a>
        <a href="#" (click)="openDeleteModal($event)" type="submit" class="btnClass btnDelete">Delete Food</a>
    </div>
</div>


</div>

<div class="modal fade" id="imgModal1" tabindex="-1" role="dialog" aria-labelledby="imgModalLabel" aria-hidden="true">
   <div class="modal-dialog modal-lg " role="document">
     <div class="modal-content modal-size-style">
       <div class="modal-header">
         <h5 class="modal-title">Food Log</h5>
         <button type="button" class="close" (click)="closeModal()" aria-label="Close">
           <span aria-hidden="true">&times;</span>
         </button>
       </div>
       <div class="modal-body">
         <img width="100%" id="modalImg" [src]="" />
       </div>
       <div class="modal-footer">
         <button type="button" class="btn btn-secondary" (click)="closeModal()"  data-dismiss="modal">Close</button>
       </div>
     </div>
   </div>
 </div>

 <!-- Delete confirmation modal -->
<div class="modal fade" [id]="'deleteFoodLogModal-' + foodAllInfo.id" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Delete Food Log</h5>
        <button type="button" class="close" aria-label="Close" (click)="cancelDelete()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this food log?
      </div>
      <div class="modal-footer" style="border-top: none;">
        <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">Confirm</button>
      </div>
    </div>
  </div>
</div>

<!-- Meal Insights Modal -->
<div class="modal fade" [id]="'mealInsightsModal-' + foodAllInfo.id" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content meal-insights-modal">
      <button type="button" class="close-btn" aria-label="Close" (click)="closeMealInsightsModal()">
        <span aria-hidden="true">&times;</span>
      </button>

      <!-- Meal Header -->
      <div class="meal-header">
        <div class="meal-image-container">
          <!-- Show barcode icon when source is barcode_scan -->
          <div *ngIf="isBarcodeScan()" class="barcode-placeholder modal-barcode">
            <svg class="barcode-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2 4h2v16H2V4zm4 0h1v16H6V4zm3 0h1v16H9V4zm2 0h2v16h-2V4zm4 0h2v16h-2V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z"/>
            </svg>
          </div>
          <!-- Show food image otherwise -->
          <img *ngIf="!isBarcodeScan()" [src]="foodAllInfo.foodImageUrl" [alt]="foodAllInfo.name" class="meal-image" />
        </div>
        <div class="meal-info">
          <h4 class="meal-name">{{foodAllInfo.name}}</h4>
          <div class="meal-details">
            <span class="meal-detail">{{foodAllInfo.logTime.split('T')[0] | date:'MMMM dd, y'}}</span>
            <span class="meal-detail">{{getDate(foodAllInfo.logTime.split('T')[1].split('.')[0])}}</span>
            <span class="meal-detail">{{foodAllInfo.mealType}}</span>
          </div>
          <div class="meal-tags">
            <span class="tag" [ngClass]="foodAllInfo.mealLocation === 'Home' ? 'tag-location-home' : 'tag-location-outside'">{{foodAllInfo.mealLocation === 'Home' ? '🏠 Home-Cooked' : '🍽️ ' + foodAllInfo.mealLocation}}</span>
            <span class="tag tag-upf" *ngIf="hasUpfFood()"><img src="assets/img/upf_flag_icon.png" alt="" class="tag-icon" /> Ultra Processed Food</span>
            <span class="tag tag-fav" *ngIf="foodAllInfo.isFavorite"><img src="assets/img/favorites_icon.png" alt="" class="tag-icon" /> Added to Favorites</span>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-container" *ngIf="isLoadingInsights">
        <div class="spinner"></div>
        <p>Loading insights...</p>
      </div>

      <!-- Error State -->
      <div class="error-container" *ngIf="insightsError && !isLoadingInsights">
        <p>No meal insights available for this food log.</p>
      </div>

      <!-- Insights Content -->
      <div class="insights-content" *ngIf="mealInsights && !isLoadingInsights">
        <!-- Meal Quality Overview -->
        <h5 class="section-title">Meal Quality Overview</h5>
        <div class="scores-container">
          <div class="score-item">
            <div class="score-circle" [style.border-color]="getScoreColor(mealInsights.greatEatingScore.score)">
              <span class="score-value">{{mealInsights.greatEatingScore.score}}</span>
            </div>
            <span class="score-label">Great Eating<br/>Score</span>
          </div>
          <div class="score-item">
            <div class="score-circle" [style.border-color]="getScoreColor(mealInsights.fullnessScore.score)">
              <span class="score-value">{{mealInsights.fullnessScore.score}}</span>
            </div>
            <span class="score-label">Fullness<br/>Score</span>
          </div>
          <div class="score-item">
            <div class="score-circle" [style.border-color]="getScoreColor(mealInsights.foodQualityScore.score)">
              <span class="score-value">{{mealInsights.foodQualityScore.score}}</span>
            </div>
            <span class="score-label">Food Quality<br/>Score</span>
          </div>
        </div>

        <!-- Meal Insights -->
        <h5 class="section-title">Meal Insights</h5>
        <div class="insights-text">
          <p *ngFor="let insight of mealInsights.insights">{{insight}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Journaling Modal -->
<div class="modal fade" [id]="'journalingModal-' + foodAllInfo.id" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content meal-insights-modal">
      <button type="button" class="close-btn" aria-label="Close" (click)="closeJournalingModal()">
        <span aria-hidden="true">&times;</span>
      </button>

      <!-- Meal Header -->
      <div class="meal-header">
        <div class="meal-image-container">
          <!-- Show barcode icon when source is barcode_scan -->
          <div *ngIf="isBarcodeScan()" class="barcode-placeholder modal-barcode">
            <svg class="barcode-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2 4h2v16H2V4zm4 0h1v16H6V4zm3 0h1v16H9V4zm2 0h2v16h-2V4zm4 0h2v16h-2V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z"/>
            </svg>
          </div>
          <!-- Show food image otherwise -->
          <img *ngIf="!isBarcodeScan()" [src]="foodAllInfo.foodImageUrl" [alt]="foodAllInfo.name" class="meal-image" />
        </div>
        <div class="meal-info">
          <h4 class="meal-name">{{foodAllInfo.name}}</h4>
          <div class="meal-details">
            <span class="meal-detail">{{foodAllInfo.logTime.split('T')[0] | date:'MMMM dd, y'}}</span>
            <span class="meal-detail">{{getDate(foodAllInfo.logTime.split('T')[1].split('.')[0])}}</span>
            <span class="meal-detail">{{foodAllInfo.mealType}}</span>
          </div>
          <div class="meal-tags">
            <span class="tag" [ngClass]="foodAllInfo.mealLocation === 'Home' ? 'tag-location-home' : 'tag-location-outside'">{{foodAllInfo.mealLocation === 'Home' ? '🏠 Home-Cooked' : '🍽️ ' + foodAllInfo.mealLocation}}</span>
            <span class="tag tag-upf" *ngIf="hasUpfFood()"><img src="assets/img/upf_flag_icon.png" alt="" class="tag-icon" /> Ultra Processed Food</span>
            <span class="tag tag-fav" *ngIf="foodAllInfo.isFavorite"><img src="assets/img/favorites_icon.png" alt="" class="tag-icon" /> Added to Favorites</span>
          </div>
        </div>
      </div>

      <!-- Journaling Content -->
      <div class="insights-content">
        <h5 class="section-title" *ngIf="foodAllInfo.journalingPrompt">{{foodAllInfo.journalingPrompt}}</h5>
        <div class="journaling-notes-box" *ngIf="foodAllInfo.journalingNote">
          <p class="notes-text notes-rich">
            <strong>Note:-</strong>
            <span class="notes-rich-body" [innerHTML]="getJournalNotesHtml(foodAllInfo.journalingNote)"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

